module.exports = __webpack_public_path__ + "img/logo.237cc466.svg";